/**
 * This component is a single Cell in the Garage (TableCompare) typically labeled Best Bank Offer.
 * The job of this component is to decide if there is complex content to render (including much more robust Redux lookups)
 * or if it should display the <DisabledCell>
 *
 * We want to do the full Redux lookup and render if:
 *     Dealer offer
 *         of type loan or lease
 *     Regular dynamic offer
 *         of type loan or lease
 *         with at least one offer in the offers array
 */

import React from "react";
import { connect } from "react-redux";
import BankOfferContents from "src/components/MyGarage/TableCompare/Cells/BankOfferCell/BankOfferContents";
import { DisabledCell } from "src/components/MyGarage/TableCompare/shared";
import { ApplicationStore } from "src/store";
import { getDealerOfferTypeByVin } from "src/store/selectors/dealerOffer";
import { getSelectedPaymentOffers, getSelectedPaymentType } from "src/store/selectors/vehicles";

interface Props {
    vin: string;
}

const BankOfferCell = ({ vin, interesting }: Props & ReturnType<typeof mapStateToProps>) => {
    if (!interesting) {
        return <DisabledCell testid={`${vin}:BestBankOffer`} />;
    }

    return <BankOfferContents vin={vin} />;
};

const mapStateToProps = (state: ApplicationStore, { vin }: Props) => {
    const dealerOfferType = getDealerOfferTypeByVin(state, vin);
    if (dealerOfferType) {
        return { interesting: dealerOfferType === "lease" || dealerOfferType === "loan" };
    }
    const customerOfferType = getSelectedPaymentType(state, vin);
    const countOffers = getSelectedPaymentOffers(state, vin).length;
    return { interesting: (customerOfferType === "lease" || customerOfferType === "loan") && countOffers >= 1 };
};

export default connect(mapStateToProps)(BankOfferCell);
